import React from 'react';

function ErrorPage() {
    return (
        <div>Error page</div>
    );
}

export default ErrorPage;
